export const BASE_URL_API_BE = process.env.REACT_APP_BE_API_V1_URL;